module.exports = __webpack_public_path__ + "static/media/sea-otter.1cf7e07a.jpg";